import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=3dc0e467&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=ts&"
export * from "./AddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0e467",
  null
  
)

export default component.exports